import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';

export default component$(
  ({ cssClasses = '' }: { cssClasses?: string }): JSX.Element => (
    <svg
      class={cssClasses}
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='17'
      viewBox='0 0 20 17'
      fill='none'
    >
      <path
        d='M11.1628 11.0195C11.1628 8.69387 11.6944 7.69719 13.887 4.57427L17.01 0.321777H20L15.5482 8.76032H19.0033V16.7337H11.1628V11.0195ZM0 16.7337V11.0195C0 8.69387 0.465117 7.69719 2.65781 4.57427L5.78073 0.321777H8.83721L4.31894 8.76032H7.77409V16.7337H0Z'
        fill='#AF261C'
      />
    </svg>
  )
);
